import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import ButtonLink from '../components/atoms/Button/buttonLink';
import { ButtonKind, ButtonSize } from '../components/atoms/Button/enums';
import MainLayout from '../components/layouts/MainLayout';
import useHeaderTitleContext from '../hooks/useHeaderTitleContext';
import routes from '../setup/consts/routes';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--s-12) var(--s-6);
  min-height: 60vh;
  text-align: center;
`;

const Code = styled.div`
  font-family: var(--font-mono, monospace);
  font-size: 6rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.04em;
  color: var(--ink);
  margin-bottom: var(--s-4);
`;

const Message = styled.p`
  font-size: var(--t-lg);
  color: var(--muted);
  margin: 0 0 var(--s-8);
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-3);
  flex-wrap: wrap;
  justify-content: center;
`;

const NotFoundPage: React.FC = () => {
  const intl = useIntl();
  const { setHeaderTitle } = useHeaderTitleContext();

  useEffect(() => {
    setHeaderTitle(
      intl.formatMessage({
        id: 'notFoundPage.pageNotFound',
        defaultMessage: 'Page Not Found',
      })
    );
  }, [intl, setHeaderTitle]);

  return (
    <MainLayout>
      <Wrapper>
        <Code>404</Code>
        <Message>
          <FormattedMessage
            id='notFoundPage.pageNotFound'
            defaultMessage='Page Not Found'
          />
        </Message>
        <Actions>
          <ButtonLink kind={ButtonKind.Primary} size={ButtonSize.Big} to={routes.ORDERS}>
            <FormattedMessage id='notFoundPage.goOrders' defaultMessage='Go to Orders' />
          </ButtonLink>
          <ButtonLink kind={ButtonKind.Outline} size={ButtonSize.Big} to={routes.DASHBOARD}>
            <FormattedMessage id='notFoundPage.goHome' defaultMessage='Dashboard' />
          </ButtonLink>
        </Actions>
      </Wrapper>
    </MainLayout>
  );
};

export default NotFoundPage;
